import { render, staticRenderFns } from "./UpdateComponent.vue?vue&type=template&id=3dd7a240"
import script from "./UpdateComponent.vue?vue&type=script&lang=js"
export * from "./UpdateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports